import { z } from 'zod/v4'
import { baseModelSchema } from '../../libs/base-model.ts'

export const clientModelSchema = baseModelSchema.extend({
  name: z.string(),
  email: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  isFavorite: z.boolean(),
  isArchived: z.boolean(),
  deletedAt: z.iso.datetime().optional().nullable(),
})
export type ClientModel = z.infer<typeof clientModelSchema>

export const clientCreateSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .pipe(z.email().optional()),
  phone: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
})
export type ClientCreate = z.infer<typeof clientCreateSchema>

export const clientUpdateSchema = z.object({
  name: z.string().min(1, 'Name is required').optional(),
  email: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .pipe(z.email().optional()),
  phone: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  isFavorite: z.boolean().optional(),
  isArchived: z.boolean().optional(),
})
export type ClientUpdate = z.infer<typeof clientUpdateSchema>
